import {
    SET_USER_ORG,
    SET_ACTIVE_USER_ORG,
    SET_ACTIVE_USER_ORG_SUCCESS,
    SET_ACTIVE_USER_ORG_FAILURE,
    SET_USER_COLLECTION,
    SET_ACTIVE_USER_PROPERTY,
    SET_ACTIVE_USER_PROPERTY_SUCCESS,
    SET_ACTIVE_USER_PROPERTY_FAILURE,
    UPDATE_USER_NOTIFICATIONS_READ_AT
} from '../actions/types';

const INITIAL_STATE = {
    userData: null,
    activePermissions: null,
    activeOrg: null,
    allOrgs: null,
    changingFocus: false,
    focusError: null,
    success: null,
    activeProperty: null,
    propertyLoading: false,
    propertyError: null
};

const userReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case SET_USER_COLLECTION:
            return {
                ...state,
                userData: action.payload
            };
        case SET_USER_ORG: {
            const initialSetPermissions = !state.activePermissions
                ? state.userData.type === 'super_admin'
                    ? state.userData.permissions
                    : state.userData.role !== 'operator'
                    ? []
                    : state.userData.orgs?.[action.payload.orgId]?.permissions ?? []
                : state.activePermissions;
            const currentOrgId = state.activeOrg?.org_id ?? action.payload.orgId;
            const freshActiveOrg =
                action.payload.orgs.find(org => org.org_id === currentOrgId) ?? state.activeOrg;
            return {
                ...state,
                allOrgs: action.payload.orgs,
                activeOrg: freshActiveOrg,
                activePermissions: initialSetPermissions
            };
        }
        case SET_ACTIVE_USER_ORG:
            return {
                ...state,
                changingFocus: true,
                focusError: null
            };
        case SET_ACTIVE_USER_ORG_SUCCESS: {
            const getActivePermissions =
                state.userData.type === 'super_admin'
                    ? state.userData.permissions
                    : state.userData.role !== 'operator'
                    ? []
                    : state.userData.orgs?.[action.payload]?.permissions ?? [];
            const getActiveOrg = state.allOrgs.filter(
                org => org.org_id === action.payload
            )[0];
            return {
                ...state,
                changingFocus: false,
                activeOrg: getActiveOrg,
                activePermissions: getActivePermissions
            };
        }
        case SET_ACTIVE_USER_ORG_FAILURE:
            return {
                ...state,
                changingFocus: false,
                focusError: action.payload
            };
        case SET_ACTIVE_USER_PROPERTY:
            return {
                ...state,
                propertyLoading: true,
                propertyError: null
            };
        case SET_ACTIVE_USER_PROPERTY_SUCCESS:
            return {
                ...state,
                userData: {
                    ...state.userData,
                    active_property_id: action.payload.id
                },
                activeProperty: action.payload,
                propertyLoading: false
            };
        case SET_ACTIVE_USER_PROPERTY_FAILURE:
            return {
                ...state,
                propertyError: action.payload,
                propertyLoading: false
            };
        case UPDATE_USER_NOTIFICATIONS_READ_AT:
            return {
                ...state,
                userData: {
                    ...state.userData,
                    notifications_read_at: action.payload
                }
            };
        default:
            return state;
    }
};

export default userReducer;
